import { cn } from "@/lib/utils";
import {
  ReferenceRangeCriticality,
  type ReferenceRanges,
} from "@/types/observations";
import { OctagonAlert, TriangleAlert } from "../ui/Icons";
import { ReferenceRangeTooltip } from "./ReferenceRangeTooltip";

interface ReferenceRangeDisplayProps {
  criticality: ReferenceRangeCriticality | null;
  data: string;
  dataClassName?: string;
  referenceRanges: ReferenceRanges | null;
  tooltipFallback: string;
  tooltipContentClassName?: string;
}

export const ReferenceRangeDisplay = ({
  tooltipFallback = "",
  criticality,
  referenceRanges,
  data,
  dataClassName,
  tooltipContentClassName,
}: ReferenceRangeDisplayProps) => {
  return (
    <ReferenceRangeTooltip
      referenceRanges={referenceRanges}
      fallbackContent={tooltipFallback}
      contentClassName={tooltipContentClassName}
    >
      <span
        className={cn(
          criticality === ReferenceRangeCriticality.HIGH_RISK &&
            "text-error font-bold tracking-wider decoration-error",
          criticality === ReferenceRangeCriticality.MODERATE_CONCERN &&
            "text-warning",
          dataClassName,
        )}
      >
        {data}
      </span>
      {criticality === ReferenceRangeCriticality.HIGH_RISK && (
        <OctagonAlert
          className="h-4 w-4 stroke-error stroke-[2.5px]"
          aria-hidden="true"
        />
      )}
      {criticality === ReferenceRangeCriticality.MODERATE_CONCERN && (
        <TriangleAlert
          className="h-4 w-4 stroke-orange-400 stroke-[2.5px]"
          aria-hidden="true"
        />
      )}
    </ReferenceRangeTooltip>
  );
};
